import React from 'react';
import { Avatar, Badge, Button, Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { cn } from '@PorkyCol/theme';
import { NotificationTemplate } from '@/context/user-notifications/helpers/types';
import { useUserNotifications } from '@/context/user-notifications/hooks';

export type NotificationType = 'default' | 'request' | 'file';

export type NotificationItemProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> &
  NotificationTemplate;

export const NotificationItem = React.forwardRef<any, NotificationItemProps>(
  (
    {
      children,
      creationDate,
      iconIdentifier,
      notification,
      id,
      title,
      description,
      className,
      ...props
    },
    ref
  ) => {
    const { markAsRead, markAsUnread } = useUserNotifications();
    /**
     * Defines the content for different types of notifications.
     */
    // const contentByType: Record<NotificationType, React.ReactNode> = {
    //   default: null,
    //   request: (
    //     <div className="flex gap-2 pt-2">
    //       <Button color="primary" size="sm">
    //         Accept
    //       </Button>
    //       <Button size="sm" variant="flat">
    //         Decline
    //       </Button>
    //     </div>
    //   ),
    //   file: (
    //     <div className="flex items-center gap-2">
    //       <Icon className="text-secondary" icon="solar:figma-file-linear" width={30} />
    //       <div className="flex flex-col">
    //         <strong className="text-small font-medium">Brand_Logo_v1.2.fig</strong>
    //         <p className="text-tiny text-default-400">3.4 MB</p>
    //       </div>
    //     </div>
    //   ),
    // };
    return (
      <div
        ref={ref}
        className={cn(
          'flex gap-3 border-b border-divider px-6 py-4',
          {
            'bg-primary-50/50': !notification?.isRead(),
          },
          className
        )}
        // onClick={() =>
        //   notification.isRead()
        //     ? markAsUnread(notification.getId())
        //     : markAsRead(notification.getId())
        // }
        {...props}
      >
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
        <div
          className="relative flex-none"
          onClick={() =>
            notification.isRead()
              ? markAsUnread(notification.getId())
              : markAsRead(notification.getId())
          }
        >
          <Badge
            color="primary"
            content=""
            isInvisible={notification?.isRead()}
            placement="top-left"
            shape="circle"
          >
            <Icon width={30} height={30} icon={iconIdentifier} />
          </Badge>
        </div>
        <div className="flex flex-col gap-0.5">
          <p className="text-small text-foreground">
            <strong className="font-medium">{title.titlePrefix}</strong>
          </p>
          <span className="text-xs text-default-500 text-left">{description.plainText}</span>
          <time className="text-tiny text-default-400">{creationDate}</time>
          {/* {type && contentByType[type]} */}
        </div>
      </div>
    );
  }
);
